"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SiteMap = void 0;
var _react = _interopRequireDefault(require("react"));
var _MapPanel = require("./MapPanel");
var _reducers = require("../redux/reducers");
var _sagas = _interopRequireDefault(require("../redux/sagas"));
require("../styles/main.css");
var _MapView = require("./Map/MapView");
var _hooks = require("../hooks");
var _paulCorePackage = require("paul-core-package");
var _constants = require("../utils/constants");
var _material = require("@mui/material");
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const SiteMapContent = _ref => {
  let {
    goTo
  } = _ref;
  const nameForm = 'sites';
  const handleRedirect = _ref2 => {
    let {
      site
    } = _ref2;
    if (!site) return;
    if (site.isApproved) {
      goTo({
        siteId: site.id,
        type: _constants.siteCardGoToKey.isApproved
      });
      return;
    }
    goTo({
      siteId: site.id,
      type: _constants.siteCardGoToKey.isForbidden
    });
  };
  return /*#__PURE__*/_react.default.createElement(_material.Box, {
    sx: {
      display: 'flex',
      height: '100vh'
    }
  }, /*#__PURE__*/_react.default.createElement(_MapView.MapView, {
    nameForm: nameForm,
    goTo: handleRedirect
  }), /*#__PURE__*/_react.default.createElement(_MapPanel.MapPanel, {
    nameForm: nameForm
  }));
};
const SiteMapConnect = _ref3 => {
  let {
    goTo
  } = _ref3;
  (0, _hooks.useConnectSites)();
  return /*#__PURE__*/_react.default.createElement(SiteMapContent, {
    goTo: goTo
  });
};
const SiteMap = _ref4 => {
  let {
    goTo
  } = _ref4;
  (0, _paulCorePackage.useInjectStore)({
    key: _constants.packageKey,
    reducer: {
      sites: _reducers.sites,
      map: _reducers.map
    },
    saga: _sagas.default
  });
  return /*#__PURE__*/_react.default.createElement(SiteMapConnect, {
    goTo: goTo
  });
};
exports.SiteMap = SiteMap;
SiteMap.protoTypes = {
  goTo: _propTypes.default.func.isRequired
};